import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import isFunction from 'lodash/isFunction';

import Map from '../../Map';

import './MapAddressRadius.css';

@inject('translationsStore')
@observer
export default class MapAddressRadius extends Component {
  constructor(props) {
    super(props);

    this.MapRef = React.createRef();

    this.state = {
      address: this.props.translationsStore.translate('savePOIModal.POIForm.addressNotAvailable')
    };
  }

  componentDidMount() {
    this.showMapSearchArea();
  }

  componentWillUnmount() {
    this.MapInstance = undefined;
  }

  componentDidUpdate() {
    this.showMapSearchArea();
  }

  showMapSearchArea = () => {
    const { lat, lng, radius } = this.props;
    this.MapInstance = this.MapRef.current.wrappedInstance;
    this.MapInstance.whenMapIsReady()
      .then(map => {
        this.MapInstance.adaptZoom(radius);
        this.MapInstance.drawCircle({ radius });
        this.MapInstance.setCenter(lat, lng);

        map.getAddressFromReverseGeocode({ lng, lat }).then(address => {
          if (this.state.address !== address.label) {
            if (isFunction(this.props.onAddressFound)) {
              this.props.onAddressFound(address.label);
            }
            this.setState({ address: address.label });
          }
        });
      })
      .catch(e => {
        console.log(e);
      });
  };

  render() {
    const { translationsStore, radius } = this.props;

    const radiusDivisor = 1000;
    const areaValue = `${Math.round(radius / radiusDivisor)} km`;

    return (
      <div className="MapAddressRadius">
        <Map
          ref={this.MapRef}
          onTap={() => false}
          className="LocationRadiusMap"
          style={{
            height: '250px',
            width: '100%'
          }}
        />

        <div className="MARTable">
          <div className="MARCell">
            <div className="MARCellLabel">{translationsStore.translate('savePOIModal.mapAddressRadius.labelStreet')}</div>
            <div className="MARCellValue">{this.state.address}</div>
          </div>
          <div className="MARCell">
            <div className="MARCellLabel">{translationsStore.translate('savePOIModal.mapAddressRadius.labelArea')}</div>
            <div className="MARCellValue">{areaValue}</div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/MapMenu/MapAddressRadius/MapAddressRadius.js